/**
 * Maximum size of one outgoing email after MIME encoding. SES SMTP accepts at
 * most 40 MB; read as decimal MB, which is the conservative interpretation.
 */
export const EMAIL_MAX_MESSAGE_BYTES = 40_000_000;
/** Approximate MIME headers per binary part (content-type, disposition, ...). */
const PART_OVERHEAD_BYTES = 512;
/** Base64 lines are wrapped at 76 characters, each break is CRLF. */
const BASE64_LINE_LENGTH = 76;
const CRLF_BYTES = 2;
const base64EncodedBytes = (rawBytes) => {
    const chars = Math.ceil(rawBytes / 3) * 4;
    return chars + Math.ceil(chars / BASE64_LINE_LENGTH) * CRLF_BYTES;
};
/**
 * Estimates the size of an email after MIME encoding. Leans towards
 * overestimation: text is counted as if base64 encoded (worst case of
 * quoted-printable/base64), binary parts as base64 with line breaks plus a
 * fixed header overhead per part.
 */
export const estimateMimeEncodedSize = ({ textBytes, binaryPartSizes, }) => base64EncodedBytes(textBytes) +
    binaryPartSizes.reduce((total, size) => total + base64EncodedBytes(size) + PART_OVERHEAD_BYTES, 0);
/**
 * Approximate raw (unencoded) attachment bytes that fit into one email, ignoring
 * body text. Meant for UI hints; the backend estimate is authoritative.
 */
export const approximateMaxRawAttachmentBytes = () => {
    const encodedPerRawByte = (4 / 3) * (1 + CRLF_BYTES / BASE64_LINE_LENGTH);
    return Math.floor((EMAIL_MAX_MESSAGE_BYTES - PART_OVERHEAD_BYTES) / encodedPerRawByte);
};
//# sourceMappingURL=emailSize.js.map